import { render, staticRenderFns } from "./TheSearchInput.vue?vue&type=template&id=8a10a5fc"
import script from "./TheSearchInput.vue?vue&type=script&lang=js"
export * from "./TheSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports